import React from 'react';
import { Box, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface OKRScoreRingProps {
    score: number; // 0.0 to 1.0
    size?: number;
    showLabel?: boolean;
}

const OKRScoreRing: React.FC<OKRScoreRingProps> = ({ score, size = 80, showLabel = true }) => {
    // Normalize score
    const safeScore = Math.max(0, Math.min(1, score || 0));

    // Status Colors (matching OKRProgressBar logic)
    // Green: >= 0.7
    // Yellow: 0.4 - 0.69
    // Red: < 0.4
    let color = '#f44336'; // Red
    if (safeScore >= 0.7) color = '#4caf50'; // Green
    else if (safeScore >= 0.4) color = '#ff9800'; // Yellow

    // Data for Pie
    const data = [
        { value: safeScore },
        { value: 1 - safeScore }
    ];

    const innerRadius = (size / 2) - 8;
    const outerRadius = (size / 2);

    return (
        <Box sx={{ width: size, height: size, position: 'relative' }}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        startAngle={90}
                        endAngle={-270}
                        dataKey="value"
                        stroke="none"
                    >
                        <Cell fill={color} />
                        <Cell fill="#e0e0e0" />
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            {showLabel && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="body2" fontWeight="bold" color="text.primary">
                        {Math.round(safeScore * 100)}%
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default OKRScoreRing;
